<template>
    <component
        :is="component"
        v-bind="$attrs"
        @accessed="accessed"
        @close="close"
    />
</template>

<script>
import AudioPlayer from "./Audio/AudioPlayer"
import ImagePlayer from "./Image/ImagePlayer"
import PdfViewer from "./PDFViewer/PdfViewer"
import ScormPlayer from "./Scorm/ScormPlayer"
import TextPlayer from "./Text/TextPlayer"
import VideoPlayer from "./Video/VideoPlayer"
import YoutubePlayer from "./Video/YoutubePlayer"

export default {
    props: {
        player: {
            type: String,
            required: true,
        },
    },

    emits: ["accessed", "close"],

    computed: {
        component() {
            switch (this.player.toLowerCase()) {
                case "image":
                    return ImagePlayer
                case "audio":
                    return AudioPlayer
                case "video":
                    return VideoPlayer
                case "text":
                    return TextPlayer
                case "pdf":
                    return PdfViewer
                case "scorm":
                    return ScormPlayer
                case "youtube":
                    return YoutubePlayer

                default:
                    throw new Error(`Invalid player ${this.player}!`)
            }
        },
    },

    methods: {
        accessed() {
            this.$emit("accessed")
        },

        close() {
            this.$emit("close")
        },
    },
}
</script>
